import React from 'react';
import { Card, CardBody } from 'reactstrap';

function DetailCard({textColor, color, avatar, header, text, buttonText, onClick, className = '', style = {}}) {
  return (
    <Card className={'card-height-100 '+className}>
      <CardBody className='d-flex flex-column align-items-center' style={style}>
        <div className='avatar-sm flex-shrink-0 mb-3'>
          <span className={`avatar-title rounded fs-3 bg-${color}`}>
            <i className={`${avatar} text-${textColor}`}></i>
          </span>
        </div>
        <h6 className='fs-15 mb-3 text-center'>{header}</h6>
        <p className='mb-1 text-muted text-center'>{text}</p>
        <button className={`w-100 btn btn-${color} mt-auto mb-0`} type='button' onClick={onClick}>Click to see</button>
      </CardBody>
    </Card>
  )
}

export default DetailCard
